import Request from '../lib/Request';
import { RecoverResidentPassword } from './contracts/External.contract';

export function recoverResidentPassword(body: RecoverResidentPassword.Body): Promise<RecoverResidentPassword.Response> {
    const route = '/external/resident/recover-password';

    return Request.post(route, body);;
};